/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterI = createReactComponent("outline", "letter-i", "IconLetterI", [["path", { "d": "M12 4l0 16", "key": "svg-0" }]]);

export { IconLetterI as default };
//# sourceMappingURL=IconLetterI.mjs.map
